/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Assign, DateRange, LeftArr, LinkIcon, MsgIcon, TableSearch } from "../../../common/svg/AllSvg";
import { useEffect, useState } from "react";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useTranslation } from "react-i18next";
import EmptyList from "../../../common/form/EmptyList";
import NoSearch from "../../../common/form/NoSearch";
import DatePicker from "react-multi-date-picker";
import Error from "../../../common/form/Error";
import PaginationComponent from "../../../common/form/PaginationComponent";
import { dataActions } from "../../../../shared/store/data-Slice";
import { useNavigate, useParams } from "react-router-dom";

const StatusWiseComplaints = ({ selectStatus, setSelectStatus, page, setPage }: any) => {
    const { t } = useTranslation('common');
    const complaintApiCall: boolean = useSelector((state: any) => state.data.complaintApiCall);
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const user: any = useSelector((state: any) => state.auth.user);
    const [data, setData] = useState([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [range, setRange] = useState<any[]>([null, null]);
    const [debouncedRange, setDebouncedRange] = useState<any[]>(range);
    const [rangeFocus, setRangeFocus] = useState<boolean>(false);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const textColor: any = {
        "Pending_Review": theme === "dark" ? "text-[#ff97a1]" : "text-[#B20516]",
        "Pending_Verification": "text-[#B2AC05]",
        // "Under_Investigation": "text-secPurple",
        "Resolved": "text-secGreen"
    }
    const bgColor: any = {
        "Pending_Review": theme === "dark" ? "bg-[#ff97a1]" : "bg-[#B20516]",
        "Pending_Verification": "bg-[#B2AC05]",
        // "Under_Investigation": "bg-secPurple",
        "Resolved": "bg-secGreen"
    }
    const complaints: any = {
        "Pending_Review": t("vigilance.home.banner.status.pending_review"),
        "Pending_Verification": t("vigilance.home.banner.status.under_investigation"),
        // "Under_Investigation": t("vigilance.home.banner.status.action_taken"),
        "Resolved": t("vigilance.home.banner.status.resolved")
    }
    const complaintStatus: any = {
        "Pending_Review": t("vigilance.home.banner.status.pending_review"), "Pending_Verification": t("vigilance.home.banner.status.under_investigation"),
        //  "Under_Investigation": t("vigilance.home.banner.status.action_taken"), 
        "Resolved": t("vigilance.home.banner.status.resolved")
    }

    const getComplaints = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.vigilance_complaint_list}${selectStatus}/?page=${page}&size=${+size?.value}${!!debouncedValue ? `&search=${debouncedValue}` : ""}${!!debouncedRange[0] ? `&start_date=${debouncedRange[0].format("YYYY-MM-DD")}` : ""}${!!debouncedRange[1] ? `&end_date=${debouncedRange[1].format("YYYY-MM-DD")}` : ""}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
                dispatch(dataActions.setComplaintApiCall(false));
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            dispatch(dataActions.setComplaintApiCall(false));
            console.error("error while fetching complaint", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedRange(range);
        }, 500);

        return () => clearTimeout(timer);
    }, [range]);

    useEffect(() => {
        window.scrollTo(0, 0);
        (!!lang && !!selectStatus) && getComplaints();
    }, [lang, debouncedValue, debouncedRange, selectStatus, page, size])

    useEffect(() => {
        complaintApiCall && getComplaints();
    }, [complaintApiCall])

    useEffect(() => {
        setPage(1);
    }, [selectStatus])

    return (
        <div className="w-full  h-full flex flex-col gap-[25px] py-[30px] xlx:py-[35px] container">
            <div className="flex  w-full lg:items-center lg:flex-row flex-col  justify-between gap-[15px]">

                <div className="flex items-center gap-[8px] ml-[-5px]">
                    <button aria-label={t("aria_label.back")} title={t("aria_label.back")} className="flex items-center justify-center w-[25px] h-[25px] rounded-full border border-transparent hover:border hover:border-[#ddd] focus:border focus:border-[#ddd] dark:focus:border-[#ffffff5e] dark:hover:border-[#ffffff5e] dark:bg-bgDarkDull bg-white" type="button" onClick={() => setSelectStatus("")}>
                        <LeftArr className="fill-primary" />
                    </button>
                    <h3 className="text-primary font-semibold whitespace-nowrap">{lang === "en" ? `All ${complaints[selectStatus]} Complaints` : lang === "hi" ? `सभी ${complaints[selectStatus]} शिकायतें` : `सर्व ${complaints[selectStatus]} तक्रारी`}</h3>
                </div>

                {(!!search || data?.length > 0 || !!range[0] || !!range[1]) && <div className="flex items-center gap-[10px] xlsm:w-auto w-full justify-end  xlsm:flex-row flex-col">
                    <div className={`border border-[rgba(134,134,134,0.15)] h-[35px] xlx:h-[40px] px-[12px] xlx:px-[15px] flex items-center gap-[7px] xlx:gap-[9px] rounded-[6px] w-full xlsm:w-[280px] xlx:w-[315px] ${searchFocus && "shadow-xl"} hover:shadow-xl`}>
                        <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-primary" />
                        <input type="text" className="text-blackDull font-semibold placeholder:text-blackDull text-sm leading-tight w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull" placeholder={t("grievance.home.banner.search")} autoComplete="off" value={search} onChange={(e: any) => { setSearch(e.target.value) }} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                    </div>

                    <div className="flex items-center gap-[10px] xlsm:w-auto w-full justify-end">
                        <div className={`flex items-center justify-center gap-[6px] xlx:gap-[9px] rounded-[6px] h-[35px] xlx:h-[40px] border border-[rgba(134,134,134,0.15)] px-[12px] xlx:px-[15px] w-fit ${rangeFocus && "shadow-[0_0_0_2px_#059db25e]"} hover:shadow-[0_0_0_2px_#059db25e]`}>
                            <DateRange />
                            <DatePicker
                                range
                                value={range}
                                onChange={(newRange: any) => {
                                    if (!newRange || newRange.length === 0) {
                                        setRange([null, null]);
                                    } else {
                                        setRange(newRange);
                                    }
                                }}
                                numberOfMonths={2}
                                placeholder="YYYY-MM-DD ~ YYYY-MM-DD"
                                onOpen={() => setRangeFocus(true)}
                                onClose={() => setRangeFocus(false)}
                            />
                        </div>

                        {/* <button className="flex items-center justify-center h-[35px] xlx:h-[40px] min-w-[35px] xlx:min-w-[40px] rounded-[6px] border border-[#DDE2E4] bg-white focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#059db25e] dark:hover:shadow-[0_0_0_2px_#059db25e] dark:bg-bgDarkDull dark:border-primary">
                            <OptionMenu />
                        </button> */}
                    </div>
                </div>}
            </div>

            {loading ?
                <div className="grid w-full h-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                        <div key={index} className="p-[15px] xlx:p-[19px] flex flex-col gap-[10px] justify-between w-full border border-gray-200 dark:border-gray-700 shadow rounded-[10px] animate-pulse">
                            <div className="flex flex-col gap-[10px] w-full">
                                <div className="w-full flex items-center justify-between gap-[15px]">
                                    <div className="w-full max-w-[166px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[76px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>

                                <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                <div className="flex flex-col gap-[4px]">
                                    <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[40px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>
                            </div>

                            <div className="flex items-center justify-between w-full">
                                <div className="flex items-center gap-[8px] xlx:gap-[10px]">
                                    <div className="w-[30px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                    <div className="w-[30px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>

                                <div className="w-[80px] rounded-[4px] h-[20px] bg-gray-200 dark:bg-gray-700"></div>
                            </div>
                        </div>
                    ))}
                </div>
                :
                <>
                    {isError ? <Error /> : <>
                        {data?.length > 0 &&
                            <>
                                <div className="grid w-full h-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                                    {Array.isArray(data) && data?.map((i: any, idx: number) => (
                                        <div className="w-full relative cursor-pointer" key={idx}>
                                            <button className={`bg-white rounded-[10px] shadow-[0px_0px_1.243px_0px_rgba(26,32,36,0.32),0px_1.243px_2.485px_0px_rgba(91,104,113,0.32)] p-[15px] xlx:p-[19px] flex flex-col gap-[10px] justify-between w-full focus:shadow-xl hover:shadow-xl ${((!!i?.assigned_department_details && !!i?.assigned_department) || user?.role === "Vigilance") && '!pb-[50px] xlx:!pb-[60px]'} h-full`} onClick={() => !!params?.lang ? navigate(`/${params?.lang}/complaint/${i?.id}`) : navigate(`/complaint/${i?.id}`)}>
                                                <div className="flex flex-col gap-[10px] w-full">
                                                    <div className="w-full flex items-center justify-between">
                                                        <h6 className="text-[#C0282C] font-bold">{i?.ticket_no}</h6>
                                                        <h6 className="text-blackDark font-medium">{moment(i?.created_at).format('MMM DD, YYYY')}</h6>
                                                    </div>

                                                    <h5 className="text-primaryText font-bold text-left break-anywhere">{i?.subject}</h5>
                                                    <h5 className="text-blackDull font-medium text-left break-anywhere">{i?.description}</h5>
                                                </div>


                                                <div className={`flex items-center justify-between w-full mb-[10px]`}>
                                                    <div className="flex items-center gap-[8px] xlx:gap-[10px]">
                                                        <div className="flex items-center gap-[6px] xlx:gap-[8px]">
                                                            <div aria-label={t("aria_label.no_of_attachs")} title={t("aria_label.no_of_attachs")}>
                                                                <LinkIcon className="fill-primary xlx:w-auto xlx:h-auto w-[12px] h-[15px]" />
                                                            </div>
                                                            <h6 className="text-blackDull font-semibold">{!!i?.attachment_count ? i?.attachment_count : 0}</h6>
                                                        </div>

                                                        <div className="flex items-center gap-[6px] xlx:gap-[8px]">
                                                            <div className="pt-[2px]" aria-label={t("aria_label.no_of_act")} title={t("aria_label.no_of_act")}>
                                                                <MsgIcon />
                                                            </div>
                                                            <h6 className="text-blackDull font-semibold">{!!i?.activities_count ? i?.activities_count : 0}</h6>
                                                        </div>
                                                    </div>

                                                    <h6 className={`h-[20px] flex items-center justify-center rounded-[4px] uppercase font-semibold px-[6px] bg-opacity-[0.15] !leading-tight ${textColor?.[i?.status]} ${bgColor?.[i?.status]}`}>
                                                        {complaintStatus?.[i?.status]}
                                                    </h6>
                                                </div>
                                            </button>
                                            <div className="absolute left-0 bottom-0 right-0 p-[15px] xlx:p-[19px] !pt-0">
                                                {(!!i?.assigned_department_details && !!i?.assigned_department) ?
                                                    <button className="gap-[8px] flex items-center hover:rounded-[9px] hover:bg-[#F8F8F8] focus:rounded-[9px] focus:bg-[#F8F8F8] h-[35px] xlx:h-[40px] justify-center px-[9px] w-fit ml-[-10px] disabled:bg-transparent" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/assign-complaint/${i?.id}`) : navigate(`/assign-complaint/${i?.id}`)} disabled={user?.role !== "Vigilance" || i?.status === "Resolved"}>
                                                        <div className="xlx:w-[28px] xlx:min-w-[28px] xlx:h-[28px] min-w-[25px] w-[25px] h-[25px] flex items-center justify-center rounded-full text-[#015293] text-[11px] xlx:text-[12px] font-semibold bg-[#F6FD8D] border border-[#42FD00] leading-tight uppercase">
                                                            {/* {i?.assigned_user_details?.first_name?.charAt(0)}{i?.assigned_user_details?.last_name?.charAt(0)} */}
                                                            {i?.assigned_department_details?.name?.charAt(0)}
                                                        </div>
                                                        <div className="flex flex-col">
                                                            {/* <p className="text-blackDull font-bold text-sm !leading-tight text-left">
                                                                {i?.assigned_user_details?.first_name + " " + i?.assigned_user_details?.last_name}
                                                            </p> */}
                                                            {/* text-blackDull font-semibold text-[11px] !leading-tight text-left */}
                                                            {!!i?.assigned_department_details?.name && <p className="text-blackDull font-bold text-sm !leading-tight text-left">{i?.assigned_department_details?.name}</p>}
                                                        </div>
                                                    </button>
                                                    :
                                                    <>
                                                        {user?.role === "Vigilance" && <button className="gap-[8px] flex items-center text-blackDull font-semibold text-sm leading-snug hover:rounded-[9px] hover:bg-[#F8F8F8] focus:rounded-[9px] focus:bg-[#F8F8F8] h-[35px] xlx:h-[40px] justify-center px-[9px] w-fit ml-[-10px]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/assign-complaint/${i?.id}`) : navigate(`/assign-complaint/${i?.id}`)}><Assign /> {t("grievance.home.assign.assign_dept")}</button>}
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="flex items-center justify-center w-full mt-[10px]">
                                    <PaginationComponent
                                        page={page}
                                        total={totalPages}
                                        setPage={setPage}
                                    />
                                </div>
                            </>
                        }

                        {(!!!range[0] && !!!range[1] && !!!search && data?.length === 0) &&
                            <EmptyList />
                        }

                        {((!!search || !!range[0] || !!range[1]) && data?.length === 0) &&
                            <NoSearch onClick={() => { setSearch(""); setRange([null, null]); }} />
                        }
                    </>}
                </>
            }
        </div >
    );
};

export default StatusWiseComplaints;